import { produce } from "immer";
import {
  TOGGLE_EMPLOYEE_MODAL,
  GET_BASIC_INFO,
  GET_BASIC_INFO_SUCCESS,
  GET_BASIC_INFO_FAILURE,
  UPDATE_BASIC_INFO,
  UPDATE_BASIC_INFO_SUCCESS,
  UPDATE_BASIC_INFO_FAILURE,
  GET_EMPLOYEEMENT_INFO,
  GET_EMPLOYEEMENT_INFO_SUCCESS,
  GET_EMPLOYEEMENT_INFO_FAILURE,
  UPDATE_EMPLOYEEMENT_INFO,
  UPDATE_EMPLOYEEMENT_INFO_SUCCESS,
  UPDATE_EMPLOYEEMENT_INFO_FAILURE,
  GET_PERMISSIONS,
  GET_PERMISSIONS_SUCCESS,
  GET_PERMISSIONS_FAILURE,
  UPDATE_PERMISSIONS,
  UPDATE_PERMISSIONS_SUCCESS,
  UPDATE_PERMISSIONS_FAILURE,
  GET_LINE_INFO,
  GET_LINE_INFO_SUCCESS,
  GET_LINE_INFO_FAILURE,
  UPDATE_LINE_INFO,
  UPDATE_LINE_INFO_SUCCESS,
  UPDATE_LINE_INFO_FAILURE,
  GET_WORKING_INFO,
  GET_WORKING_INFO_SUCCESS,
  GET_WORKING_INFO_FAILURE,
  UPDATE_WORKING_INFO,
  UPDATE_WORKING_INFO_SUCCESS,
  UPDATE_WORKING_INFO_FAILURE,
  GET_ROLE_INFO,
  GET_ROLE_INFO_SUCCESS,
  GET_ROLE_INFO_FAILURE,
  UPDATE_ROLE_INFO,
  UPDATE_ROLE_INFO_SUCCESS,
  UPDATE_ROLE_INFO_FAILURE,
  GET_WORKING_LOCATIONS,
  GET_WORKING_LOCATIONS_SUCCESS,
  GET_WORKING_LOCATIONS_FAILURE,
  UPDATE_LOCATIONS,
  UPDATE_LOCATIONS_SUCCESS,
  UPDATE_LOCATIONS_FAILURE,
  GET_ONBOARDING_STEPS,
  GET_ONBOARDING_STEPS_SUCCESS,
  GET_ONBOARDING_STEPS_FAILURE,
  GET_STEP_DETAILS,
  GET_STEP_DETAILS_SUCCESS,
  GET_STEP_DETAILS_FAILURE,
  SET_FIELDS,
  TOGGLE_APPROVE_MODAL,
  TOGGLE_STEP_APPROVE_MODAL,
  APPROVE_FIELD,
  APPROVE_FIELD_SUCCESS,
  APPROVE_FIELD_FAILURE,
  GET_PERSONAL_INFO,
  GET_PERSONAL_INFO_SUCCESS,
  GET_PERSONAL_INFO_FAILURE,
  UPDATE_PERSONAL_INFO,
  UPDATE_PERSONAL_INFO_SUCCESS,
  UPDATE_PERSONAL_INFO_FAILURE,
  GET_DOCUMENTS,
  GET_DOCUMENTS_SUCCESS,
  GET_DOCUMENTS_FAILURE,
  GET_HOLIDAY_INFO,
  GET_HOLIDAY_INFO_SUCCESS,
  GET_HOLIDAY_INFO_FAILURE,
  GET_LEAVES,
  GET_LEAVES_SUCCESS,
  GET_LEAVES_FAILURE,
  UPDATE_HOLIDAY_INFO,
  UPDATE_HOLIDAY_INFO_SUCCESS,
  UPDATE_HOLIDAY_INFO_FAILURE,
  GET_PAYROLL_INFO,
  GET_PAYROLL_INFO_SUCCESS,
  GET_PAYROLL_INFO_FAILURE,
  UPDATE_PAYROLL_INFO,
  UPDATE_PAYROLL_INFO_SUCCESS,
  UPDATE_PAYROLL_INFO_FAILURE,
  TOGGLE_STEP_FILE_MODAL,
  TOGGLE_VIEW_FILE_MODAL,
  DOWNLOAD_FILE,
  DOWNLOAD_FILE_SUCCESS,
  DOWNLOAD_FILE_FAILURE,
  DELETE_FILE,
  DELETE_FILE_SUCCESS,
  DELETE_FILE_FAILURE,
  GET_VERSION_HISTORY,
  GET_VERSION_HISTORY_SUCCESS,
  GET_VERSION_HISTORY_FAILURE,
  SEND_REVISION_MAIL,
  SEND_REVISION_MAIL_SUCCESS,
  SEND_REVISION_MAIL_FAILURE,
  GET_DOC_VERSIONS,
  GET_DOC_VERSIONS_SUCCESS,
  GET_DOC_VERSIONS_FAILURE,
  SEND_DOC_MAIL,
  SEND_DOC_MAIL_SUCCESS,
  SEND_DOC_MAIL_FAILURE,
  GET_DOC_CORRECTIONS,
  GET_DOC_CORRECTIONS_SUCCESS,
  GET_DOC_CORRECTIONS_FAILURE,
  UPLOAD_NEW_DOC,
  UPLOAD_NEW_DOC_SUCCESS,
  UPLOAD_NEW_DOC_FAILURE,
  GET_STEP_HISTORY,
  GET_STEP_HISTORY_SUCCESS,
  GET_STEP_HISTORY_FAILURE,
  TOGGLE_STEP_HISTORY_MODAL,
  SET_STEP_TITLE,
  UPDATE_ONBOARDING_DATA,
  GET_ADDITIONAL_DOCUMENTS,
  GET_ADDITIONAL_DOCUMENTS_SUCCESS,
  GET_ADDITIONAL_DOCUMENTS_FAILURE,
  TOGGLE_ADDITIONAL_DOCUMENT_MODAL,
  GET_DOCS_HISTORY,
  GET_DOCS_HISTORY_SUCCESS,
  GET_DOCS_HISTORY_FAILURE,
  EDIT_VERSION_FILE,
  EDIT_VERSION_FILE_SUCCESS,
  EDIT_VERSION_FILE_FAILURE,
} from "./constants";

export const initialState = {
  employeeModal: { open: false },
  // Basic Info
  basicInfo: {},
  isFetchingInfo: false,
  isUpdatingInfo: false,
  // Employment Info
  employmentInfo: {},
  isUpdatingEmploymentInfo: false,
  isFetchingEmploymentInfo: false,
  // Permissions
  permissions: {},
  isFetchingPermissions: false,
  isUpdatingPermissions: false,
  // Line Info
  lineInfo: {},
  isFetchingLineInfo: false,
  isUpdatingLineInfo: false,
  // Working Info
  workingInfo: {},
  isFetchingWorkingInfo: false,
  isUpdatingWorkingInfo: false,
  // Role Info
  roleInfo: {},
  isFetchingRoleInfo: false,
  isUpdatingRoleInfo: false,
  // Working Locations
  workingLocations: [],
  isFetchingWorkingLocations: false,
  isUpdatingWorkingLocations: false,
  // Onboarding Steps
  onboardingSteps: [],
  isFetchingOnboardingSteps: false,
  isUpdatingOnboardingSteps: false,
  // Step Details
  stepDetails: {},
  isFetchingStepDetails: false,
  fields: [],
  approveModal: { open: false },
  stepApproveModal: { open: false },
  isApprovingField: false,
  // Personal Info
  personalInfo: {},
  isFetchingPersonalInfo: false,
  isUpdatingPersonalInfo: false,
  // Documents
  documents: [],
  isFetchingDocuments: false,
  isUpdatingDocuments: false,
  // Holiday Info
  holidayInfo: {},
  isFetchingHolidayInfo: false,
  isUpdatingHolidayInfo: false,
  // Leaves
  leaves: [],
  isFetchingLeaves: false,
  // Payroll Info
  payrollInfo: {},
  isFetchingPayrollInfo: false,
  isUpdatingPayrollInfo: false,
  // Step File Modal
  stepFileModal: { open: false },
  // View File Modal
  viewFileModal: { open: false },
  // Download File
  isDownloadingFile: false,
  // Delete File
  isDeletingFile: false,
  // Version History
  versionHistory: [],
  isFetchingHistory: false,
  // Send Revision Mail
  isSendingRevisionMail: false,
  // Doc Versions
  docVersions: [],
  isFetchingDocVersions: false,
  // Send Doc Mail
  isSendingDocMail: false,
  // Doc Corrections
  docCorrections: [],
  isFetchingDocCorrections: false,
  // Step History
  stepHistory: [],
  isFetchingStepHistory: false,
  // Step History Modal
  stepHistoryModal: { open: false },
  // Step Title
  stepTitle: null,
  // Onboarding Data
  onboardingData: [],
  isUpdatingOnboardingData: false,
  // Additional Documents
  additionalDocuments: [],
  isFetchingAdditionalDocuments: false,
  additionalDocumentModal: false,
  // Docs History
  docsHistory: [],
  isFetchingDocsHistory: false,
  // Edit Version File
  isEditingVersionFile: false,
};

const EmployeeEditReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case TOGGLE_EMPLOYEE_MODAL:
        draft.employeeModal = action.payload;
        break;
      case GET_BASIC_INFO:
        draft.isFetchingInfo = true;
        draft.basicInfo = {};
        break;
      case GET_BASIC_INFO_SUCCESS:
        draft.isFetchingInfo = false;
        draft.basicInfo = action.payload;
        break;
      case GET_BASIC_INFO_FAILURE:
        draft.isFetchingInfo = false;
        draft.basicInfo = {};
        break;
      case UPDATE_BASIC_INFO:
        draft.isUpdatingInfo = true;
        break;
      case UPDATE_BASIC_INFO_SUCCESS:
        draft.isUpdatingInfo = false;
        break;
      case UPDATE_BASIC_INFO_FAILURE:
        draft.isUpdatingInfo = false;
        break;
      case GET_EMPLOYEEMENT_INFO:
        draft.isFetchingEmploymentInfo = true;
        draft.employmentInfo = {};
        break;
      case GET_EMPLOYEEMENT_INFO_SUCCESS:
        draft.isFetchingEmploymentInfo = false;
        draft.employmentInfo = action.payload;
        break;
      case GET_EMPLOYEEMENT_INFO_FAILURE:
        draft.isFetchingEmploymentInfo = false;
        draft.employmentInfo = {};
        break;
      case UPDATE_EMPLOYEEMENT_INFO:
        draft.isUpdatingEmploymentInfo = true;
        break;
      case UPDATE_EMPLOYEEMENT_INFO_SUCCESS:
        draft.isUpdatingEmploymentInfo = false;
        break;
      case UPDATE_EMPLOYEEMENT_INFO_FAILURE:
        draft.isUpdatingEmploymentInfo = false;
        break;
      case GET_PERMISSIONS:
        draft.isFetchingPermissions = true;
        draft.permissions = {};
        break;
      case GET_PERMISSIONS_SUCCESS:
        draft.isFetchingPermissions = false;
        draft.permissions = action.payload;
        break;
      case GET_PERMISSIONS_FAILURE:
        draft.isFetchingPermissions = false;
        draft.permissions = {};
        break;
      case UPDATE_PERMISSIONS:
        draft.isUpdatingPermissions = true;
        break;
      case UPDATE_PERMISSIONS_SUCCESS:
        draft.isUpdatingPermissions = false;
        break;
      case UPDATE_PERMISSIONS_FAILURE:
        draft.isUpdatingPermissions = false;
        break;
      case GET_LINE_INFO:
        draft.isFetchingLineInfo = true;
        draft.lineInfo = {};
        break;
      case GET_LINE_INFO_SUCCESS:
        draft.isFetchingLineInfo = false;
        draft.lineInfo = action.payload;
        break;
      case GET_LINE_INFO_FAILURE:
        draft.isFetchingLineInfo = false;
        draft.lineInfo = {};
        break;
      case UPDATE_LINE_INFO:
        draft.isUpdatingLineInfo = true;
        break;
      case UPDATE_LINE_INFO_SUCCESS:
        draft.isUpdatingLineInfo = false;
        break;
      case UPDATE_LINE_INFO_FAILURE:
        draft.isUpdatingLineInfo = false;
        break;
      case GET_WORKING_INFO:
        draft.isFetchingWorkingInfo = true;
        draft.workingInfo = {};
        break;
      case GET_WORKING_INFO_SUCCESS:
        draft.isFetchingWorkingInfo = false;
        draft.workingInfo = action.payload;
        break;
      case GET_WORKING_INFO_FAILURE:
        draft.isFetchingWorkingInfo = false;
        draft.workingInfo = {};
        break;
      case UPDATE_WORKING_INFO:
        draft.isUpdatingWorkingInfo = true;
        break;
      case UPDATE_WORKING_INFO_SUCCESS:
        draft.isUpdatingWorkingInfo = false;
        break;
      case UPDATE_WORKING_INFO_FAILURE:
        draft.isUpdatingWorkingInfo = false;
        break;
      case GET_ROLE_INFO:
        draft.isFetchingRoleInfo = true;
        draft.roleInfo = {};
        break;
      case GET_ROLE_INFO_SUCCESS:
        draft.isFetchingRoleInfo = false;
        draft.roleInfo = action.payload;
        break;
      case GET_ROLE_INFO_FAILURE:
        draft.isFetchingRoleInfo = false;
        draft.roleInfo = {};
        break;
      case UPDATE_ROLE_INFO:
        draft.isUpdatingRoleInfo = true;
        break;
      case UPDATE_ROLE_INFO_SUCCESS:
        draft.isUpdatingRoleInfo = false;
        break;
      case UPDATE_ROLE_INFO_FAILURE:
        draft.isUpdatingRoleInfo = false;
        break;
      case GET_WORKING_LOCATIONS:
        draft.isFetchingWorkingLocations = true;
        draft.workingLocations = [];
        break;
      case GET_WORKING_LOCATIONS_SUCCESS:
        draft.isFetchingWorkingLocations = false;
        draft.workingLocations = action.payload;
        break;
      case GET_WORKING_LOCATIONS_FAILURE:
        draft.isFetchingWorkingLocations = false;
        draft.workingLocations = [];
        break;
      case UPDATE_LOCATIONS:
        draft.isUpdatingWorkingLocations = true;
        break;
      case UPDATE_LOCATIONS_SUCCESS:
        draft.isUpdatingWorkingLocations = false;
        break;
      case UPDATE_LOCATIONS_FAILURE:
        draft.isUpdatingWorkingLocations = false;
        break;
      case GET_ONBOARDING_STEPS:
        draft.isFetchingOnboardingSteps = true;
        draft.onboardingSteps = [];
        break;
      case GET_ONBOARDING_STEPS_SUCCESS:
        draft.isFetchingOnboardingSteps = false;
        draft.onboardingSteps = action.payload;
        break;
      case GET_ONBOARDING_STEPS_FAILURE:
        draft.isFetchingOnboardingSteps = false;
        draft.onboardingSteps = [];
        break;
      case GET_STEP_DETAILS:
        draft.isFetchingStepDetails = true;
        draft.stepDetails = {};
        break;
      case GET_STEP_DETAILS_SUCCESS:
        draft.isFetchingStepDetails = false;
        draft.stepDetails = action.payload;
        break;
      case GET_STEP_DETAILS_FAILURE:
        draft.isFetchingStepDetails = false;
        draft.stepDetails = {};
        break;
      case SET_FIELDS:
        draft.fields = action.payload;
        break;
      case TOGGLE_APPROVE_MODAL:
        draft.approveModal = action.payload;
        break;
      case TOGGLE_STEP_APPROVE_MODAL:
        draft.stepApproveModal = action.payload;
        break;
      case TOGGLE_STEP_FILE_MODAL:
        draft.stepFileModal = action.payload;
        break;
      case APPROVE_FIELD:
        draft.isApprovingField = true;
        break;
      case APPROVE_FIELD_SUCCESS:
        draft.isApprovingField = false;
        break;
      case APPROVE_FIELD_FAILURE:
        draft.isApprovingField = false;
        break;
      case GET_PERSONAL_INFO:
        draft.isFetchingPersonalInfo = true;
        draft.personalInfo = {};
        break;
      case GET_PERSONAL_INFO_SUCCESS:
        draft.isFetchingPersonalInfo = false;
        draft.personalInfo = action.payload;
        break;
      case GET_PERSONAL_INFO_FAILURE:
        draft.isFetchingPersonalInfo = false;
        draft.personalInfo = {};
        break;
      case UPDATE_PERSONAL_INFO:
        draft.isUpdatingPersonalInfo = true;
        break;
      case UPDATE_PERSONAL_INFO_SUCCESS:
        draft.isUpdatingPersonalInfo = false;
        break;
      case UPDATE_PERSONAL_INFO_FAILURE:
        draft.isUpdatingPersonalInfo = false;
        break;
      case GET_DOCUMENTS:
        draft.isFetchingDocuments = true;
        draft.documents = [];
        break;
      case GET_DOCUMENTS_SUCCESS:
        draft.isFetchingDocuments = false;
        draft.documents = action.payload;
        break;
      case GET_DOCUMENTS_FAILURE:
        draft.isFetchingDocuments = false;
        draft.documents = [];
        break;
      case GET_HOLIDAY_INFO:
        draft.isFetchingHolidayInfo = true;
        draft.holidayInfo = {};
        break;
      case GET_HOLIDAY_INFO_SUCCESS:
        draft.isFetchingHolidayInfo = false;
        draft.holidayInfo = action.payload;
        break;
      case GET_HOLIDAY_INFO_FAILURE:
        draft.isFetchingHolidayInfo = false;
        draft.holidayInfo = {};
        break;
      case GET_LEAVES:
        draft.isFetchingLeaves = true;
        draft.leaves = {};
        break;
      case GET_LEAVES_SUCCESS:
        draft.isFetchingLeaves = false;
        draft.leaves = action.payload;
        break;
      case GET_LEAVES_FAILURE:
        draft.isFetchingLeaves = false;
        draft.leaves = {};
        break;
      case UPDATE_HOLIDAY_INFO:
        draft.isUpdatingHolidayInfo = true;
        break;
      case UPDATE_HOLIDAY_INFO_SUCCESS:
        draft.isUpdatingHolidayInfo = false;
        break;
      case UPDATE_HOLIDAY_INFO_FAILURE:
        draft.isUpdatingHolidayInfo = false;
        break;
      case GET_PAYROLL_INFO:
        draft.isFetchingPayrollInfo = true;
        draft.payrollInfo = {};
        break;
      case GET_PAYROLL_INFO_SUCCESS:
        draft.isFetchingPayrollInfo = false;
        draft.payrollInfo = action.payload;
        break;
      case GET_PAYROLL_INFO_FAILURE:
        draft.isFetchingPayrollInfo = false;
        draft.payrollInfo = {};
        break;
      case UPDATE_PAYROLL_INFO:
        draft.isUpdatingPayrollInfo = true;
        break;
      case UPDATE_PAYROLL_INFO_SUCCESS:
        draft.isUpdatingPayrollInfo = false;
        break;
      case UPDATE_PAYROLL_INFO_FAILURE:
        draft.isUpdatingPayrollInfo = false;
        break;
      case TOGGLE_VIEW_FILE_MODAL:
        draft.viewFileModal = action.payload;
        break;
      case DOWNLOAD_FILE:
        draft.isDownloadingFile = true;
        break;
      case DOWNLOAD_FILE_SUCCESS:
        draft.isDownloadingFile = false;
        break;
      case DOWNLOAD_FILE_FAILURE:
        draft.isDownloadingFile = false;
        break;
      case DELETE_FILE:
        draft.isDeletingFile = true;
        break;
      case DELETE_FILE_SUCCESS:
        draft.isDeletingFile = false;
        break;
      case DELETE_FILE_FAILURE:
        draft.isDeletingFile = false;
        break;
      case GET_VERSION_HISTORY:
        draft.isFetchingHistory = true;
        draft.versionHistory = [];
        break;
      case GET_VERSION_HISTORY_SUCCESS:
        draft.isFetchingHistory = false;
        draft.versionHistory = action.payload;
        break;
      case GET_VERSION_HISTORY_FAILURE:
        draft.isFetchingHistory = false;
        draft.versionHistory = [];
        break;
      case SEND_REVISION_MAIL:
        draft.isSendingRevisionMail = true;
        break;
      case SEND_REVISION_MAIL_SUCCESS:
        draft.isSendingRevisionMail = false;
        break;
      case SEND_REVISION_MAIL_FAILURE:
        draft.isSendingRevisionMail = false;
        break;
      case GET_DOC_VERSIONS:
        draft.isFetchingDocVersions = true;
        draft.docVersions = [];
        break;
      case GET_DOC_VERSIONS_SUCCESS:
        draft.isFetchingDocVersions = false;
        draft.docVersions = action.payload;
        break;
      case GET_DOC_VERSIONS_FAILURE:
        draft.isFetchingDocVersions = false;
        draft.docVersions = [];
        break;
      case SEND_DOC_MAIL:
        draft.isSendingDocMail = true;
        break;
      case SEND_DOC_MAIL_SUCCESS:
        draft.isSendingDocMail = false;
        break;
      case SEND_DOC_MAIL_FAILURE:
        draft.isSendingDocMail = false;
        break;
      case GET_DOC_CORRECTIONS:
        draft.isFetchingDocCorrections = true;
        draft.docCorrections = [];
        break;
      case GET_DOC_CORRECTIONS_SUCCESS:
        draft.isFetchingDocCorrections = false;
        draft.docCorrections = action.payload;
        break;
      case GET_DOC_CORRECTIONS_FAILURE:
        draft.isFetchingDocCorrections = false;
        draft.docCorrections = [];
        break;
      case UPLOAD_NEW_DOC:
        draft.isUploadingNewDoc = true;
        break;
      case UPLOAD_NEW_DOC_SUCCESS:
        draft.isUploadingNewDoc = false;
        break;
      case UPLOAD_NEW_DOC_FAILURE:
        draft.isUploadingNewDoc = false;
        break;

      case GET_STEP_HISTORY:
        draft.isFetchingStepHistory = true;
        draft.stepHistory = {};
        break;
      case GET_STEP_HISTORY_SUCCESS:
        draft.isFetchingStepHistory = false;
        draft.stepHistory = action.payload;
        break;
      case GET_STEP_HISTORY_FAILURE:
        draft.isFetchingStepHistory = false;
        draft.stepHistory = {};
        break;

      case TOGGLE_STEP_HISTORY_MODAL:
        draft.stepHistoryModal = action.payload;
        break;

      case SET_STEP_TITLE:
        draft.stepTitle = action.payload;
        break;

      case UPDATE_ONBOARDING_DATA:
        draft.isUpdatingOnboardingData = true;
        break;

      case GET_ADDITIONAL_DOCUMENTS:
        draft.isFetchingAdditionalDocuments = true;
        draft.additionalDocuments = [];
        break;
      case GET_ADDITIONAL_DOCUMENTS_SUCCESS:
        draft.isFetchingAdditionalDocuments = false;
        draft.additionalDocuments = action.payload;
        break;
      case GET_ADDITIONAL_DOCUMENTS_FAILURE:
        draft.isFetchingAdditionalDocuments = false;
        draft.additionalDocuments = [];
        break;
      case TOGGLE_ADDITIONAL_DOCUMENT_MODAL:
        draft.additionalDocumentModal = action.payload;
        break;
      case GET_DOCS_HISTORY:
        draft.isFetchingDocsHistory = true;
        draft.docsHistory = {};
        break;
      case GET_DOCS_HISTORY_SUCCESS:
        draft.isFetchingDocsHistory = false;
        draft.docsHistory = action.payload;
        break;
      case GET_DOCS_HISTORY_FAILURE:
        draft.isFetchingDocsHistory = false;
        draft.docsHistory = {};
        break;
      case EDIT_VERSION_FILE:
        draft.isEditingVersionFile = true;
        break;
      case EDIT_VERSION_FILE_SUCCESS:
        draft.isEditingVersionFile = false;
        break;
      case EDIT_VERSION_FILE_FAILURE:
        draft.isEditingVersionFile = false;
        break;
      default:
        return state;
    }
  });

export default EmployeeEditReducer;
